export default __webpack_public_path__ + "static/107984-aae23c3a0ed33025b6437680faaecdb1.jpg";